import type { PageviewRequest } from '@bpd/shared';

const PAGEVIEW_API_URL = import.meta.env.VITE_PAGEVIEW_API_URL;

/**
 * Fire-and-forget beacon for public-site traffic. No-ops if the endpoint
 * isn't configured (e.g. local dev before TrafficStack is deployed) and
 * swallows errors — a failed beacon must never affect the visitor.
 */
export function recordPageview(path: string, referrer?: string): void {
  if (!PAGEVIEW_API_URL) return;

  const body: PageviewRequest = { path, ...(referrer ? { referrer } : {}) };
  void fetch(PAGEVIEW_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => {
    // Best-effort — ignore network/CORS failures.
  });
}
